import { useI18n as useVueI18n } from 'vue-i18n';
import { computed } from 'vue';

// 封装 useI18n
export function useI18n() {
  const { t, locale } = useVueI18n();
  return { t, locale };
}

// 封装 useLocale
export function useLocale() {
  const { locale } = useVueI18n();

  const getLocale = computed(() => locale.value);

  const changeLocale = (lang: string) => {
    locale.value = lang;
    localStorage.setItem('locale', lang);
    // 可选：设置 html lang 属性
    document.querySelector('html')?.setAttribute('lang', lang);
  };

  return {
    getLocale,
    changeLocale,
  };
}
